import { Component } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import {
  IProductDigemid,
  PRODUCTDIGEMID_TTL_ES
} from '../../product-of-digemid.interface';
import { ProductDigemidService } from '../../product-of-digemid.service';
import { getTagColor } from '../../../../../../helpers/tag-color.helpers';

@Component({
  selector: 'pg-digemid-products-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class ProductDigemidSelectComponent extends SelectTemplate {
  constructor(private serviceBase: ProductDigemidService) {
    super(PRODUCTDIGEMID_TTL_ES, serviceBase);
  }

  async ngOnInit() {
    this.table.settings = {
      title: PRODUCTDIGEMID_TTL_ES,
      columns: [
        { header: 'Código', field: 'code' },
        { header: 'Nombre', field: 'name' },
        { header: 'Concentración', field: 'concentration' },
        { header: 'FormDet', field: 'form' },
        { header: 'FormSimp', field: 'formSimp' },
        { header: 'Presentación', field: 'presentation' },
        { header: 'Laboratorio', field: 'laboratory' },
        { header: 'Fracción', field: 'fractions' },
        { header: 'Condición', field: 'condition', tag: 'tagStatus' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IProductDigemid[]) => {
        data = data.map((item) => {
          item.tagStatusColor = getTagColor(item.conditionCode);
          return item;
        });
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
